import user from 'modules/user/reducers'
import dictionary from 'modules/dictionary/reducers'
import car from 'modules/car/reducers'
import app from 'modules/app/reducers'
import drivers from 'modules/drivers/reducers'

export default { user, dictionary, car, app, drivers }
